import React, { useEffect, useContext } from 'react'
import { Container, ColorBackground, BlurBackground } from './style'
import ModalContext from '../../contexts/ModalContext'
import AddStockMenu from '../AddStockModal'
import FirstCustomAddPage from '../AddStockModal/CustomAdd/FirstPage'
import SecondCustomAddPage from '../AddStockModal/CustomAdd/SecondPage'
import ThirdCustomAddPage from '../AddStockModal/CustomAdd/ThirdPage'
import UploadStep from '../AddStockModal/ImportExcelModal/Upload'
import MappingStep from '../AddStockModal/ImportExcelModal/Mapping'
import RevisionStep from '../AddStockModal/ImportExcelModal/Revision'
import FollowingStep from '../AddStockModal/ImportExcelModal/Following'
import OrdersDetails from '../Orders/DetailsModal'
import CreateProfile from '../CreateProfileModal'
import RouterModal from '../routerModal'
import InviteNewAdmin from '../InviteNewAdmin'
import { DeleteProfile } from '../DeleteProfileModal'
import AddParameterModal from '../AddParameterModal/Add'
import EditParameterModal from '../AddParameterModal/Edit'
import CreateOPModal from '../Services/CreateServiceModal'
import CreateUserModal from '../ProductionUsers/CreateUserModal'
import CheckServiceOrderModal from '../Services/CheckServiceOrderModal'
import CheckUserModal from '../ProductionUsers/CheckUserModal'
import CreateMachineModal from '../Machines/CreateMachineModal'
import CheckMachineModal from '../Machines/CheckMachineModal'
import CheckReportModal from '../Reports/CheckReport'
import DimensionsModal from '../Services/CreateServiceModal/DimensionsModal'
import QRCodeModal from '../QRCodeModal'
import AddCompanyModal from '../AddCompanyModal'
import CreateAFunctionModal from '../CreateAFunctionModal'
import ViewCertificateModal from '../Certificates/ViewCertificateModal'
import EntryOrExit from '../ModalEntryOrExit'
import NewModal from '../NewModal'
import AddProductForm from '../../pages/ClientPanel/FashionOrders/AddProductForm'
import ViewProductionFashion from '../../pages/ClientPanel/ProductionFashion/ViewProductionModal'
import AddFashionOP from '../../pages/ClientPanel/ProductionFashion/AddFashionOP'
import ViewEquipmentModal from '../../pages/ClientPanel/Equipment/Machines/ViewEquipmentModal'
import ChangeCodeModal from '../../pages/ClientPanel/Stock/New code/ChangeCodeModal'

const BaseModal: React.FC = () => {
  const { setModalActive, modalSection } = useContext(ModalContext)
  
  useEffect(() => {
    console.log('🗖️ [MODAL-COMPONENT] Modal section alterada:', {
      modalSection,
      timestamp: new Date().toISOString()
    });
    
    if (modalSection.includes('CustomAdd')) {
      console.log('📦 [MODAL-COMPONENT] Fluxo de adição de estoque detectado:', {
        currentPage: modalSection,
        isFirstPage: modalSection === 'firstCustomAdd',
        isSecondPage: modalSection === 'secondCustomAdd', 
        isThirdPage: modalSection === 'thirdCustomAdd'
      });
    }
  }, [modalSection]);

  console.log('🗖️ [MODAL-COMPONENT] Renderizando modal:', { modalSection });

  return (
    <Container>
      {modalSection === 'addStockMenu' && <AddStockMenu />}
      {modalSection === 'firstCustomAdd' && <FirstCustomAddPage />}
      {modalSection === 'secondCustomAdd' && <SecondCustomAddPage />}
      {modalSection === 'thirdCustomAdd' && <ThirdCustomAddPage />}
      {modalSection === 'firstExcelAdd' && <UploadStep />}
      {modalSection === 'secondExcelAdd' && <MappingStep />}
      {modalSection === 'thirdExcelAdd' && <RevisionStep />}
      {modalSection === 'fourthExcelAdd' && <FollowingStep />}
      {modalSection === 'ordersDetails' && <OrdersDetails />}
      {modalSection === 'viewCertificate' && <ViewCertificateModal />}
      {modalSection === 'addParamStructure' && <AddParameterModal />}
      {modalSection === 'editParamStructure' && <EditParameterModal />}
      {modalSection === 'addCustomer' && <AddCompanyModal />}
      {modalSection === 'addCompany' && <AddCompanyModal />}
      {modalSection === 'addSupplier' && <AddCompanyModal />}
      {modalSection === 'createProfile' && <CreateProfile />}
      {modalSection === 'inviteNewAdmin' && <InviteNewAdmin />}
      {modalSection === 'deleteProfile' && <DeleteProfile />}
      {modalSection.includes('router') && <RouterModal />}
      {modalSection === 'createService' && <CreateOPModal />}
      {modalSection === 'editService' && <CreateOPModal />}
      {modalSection === 'insertDimensions' && <DimensionsModal />}
      {modalSection === 'createUser' && <CreateUserModal />}
      {modalSection === 'editUser' && <CreateUserModal />}
      {modalSection === 'createMachine' && <CreateMachineModal />}
      {modalSection === 'editMachine' && <CreateMachineModal />}
      {modalSection === 'checkOrderService' && <CheckServiceOrderModal />}
      {modalSection === 'checkUser' && <CheckUserModal />}
      {modalSection === 'checkMachine' && <CheckMachineModal />}
      {modalSection === 'checkReport' && <CheckReportModal />}
      {modalSection === 'modalEntryOrExit' && <EntryOrExit />}
      {modalSection === 'newModal' && <NewModal />}
      {modalSection === 'viewQrCode' && <QRCodeModal />}
      {modalSection === 'createNewFunction' && <CreateAFunctionModal />}
      {modalSection === 'viewProductionFashion' && <ViewProductionFashion />}

      <ColorBackground />
      <BlurBackground onClick={() => setModalActive(false)} />
    </Container>
  )
}

export default BaseModal